import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex items-center justify-between" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = {
  key: 4,
  class: "mt-6 bg-gray-50 rounded text-sm p-3 grid gap-2 grid-flow-col text-gray-600 dark:bg-gray-800 dark:text-gray-400"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Trades from ETH route through Balancer liquidity pools and incur gas fees. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" to avoid gas. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TradeSettingsPopover = _resolveComponent("TradeSettingsPopover")
  const _component_TradePairGP = _resolveComponent("TradePairGP")
  const _component_BalAlert = _resolveComponent("BalAlert")
  const _component_BalBtn = _resolveComponent("BalBtn")
  const _component_LightBulbIcon = _resolveComponent("LightBulbIcon")
  const _component_BalCard = _resolveComponent("BalCard")
  const _component_TradePreviewModalGP = _resolveComponent("TradePreviewModalGP")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_BalCard, {
      class: "relative",
      shadow: _ctx.tradeCardShadow,
      "no-border": ""
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_TradeSettingsPopover, {
            context: _ctx.TradeSettingsContext.trade
          }, null, 8, ["context"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode(_component_TradePairGP, {
            "token-in-amount-input": _ctx.tokenInAmount,
            "token-in-address-input": _ctx.tokenInAddress,
            "token-out-amount-input": _ctx.tokenOutAmount,
            "token-out-address-input": _ctx.tokenOutAddress,
            "exact-in": _ctx.exactIn,
            "effective-price-message": _ctx.trading.effectivePriceMessage,
            onTokenInAmountChange: _cache[1] || (_cache[1] = value => (_ctx.tokenInAmount = value)),
            onTokenInAddressChange: _cache[2] || (_cache[2] = value => (_ctx.tokenInAddress = value)),
            onTokenOutAmountChange: _cache[3] || (_cache[3] = value => (_ctx.tokenOutAmount = value)),
            onTokenOutAddressChange: _cache[4] || (_cache[4] = value => (_ctx.tokenOutAddress = value)),
            onExactInChange: _cache[5] || (_cache[5] = value => (_ctx.exactIn = value)),
            onChange: _ctx.trading.handleAmountChange
          }, null, 8, ["token-in-amount-input", "token-in-address-input", "token-out-amount-input", "token-out-address-input", "exact-in", "effective-price-message", "onChange"]),
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_BalAlert, {
                key: 0,
                class: "p-3 mb-4",
                type: "error",
                size: "sm",
                title: _ctx.error.header,
                description: _ctx.error.body,
                "action-label": _ctx.error.label,
                block: "",
                onActionClick: _ctx.handleErrorButtonClick
              }, null, 8, ["title", "description", "action-label", "onActionClick"]))
            : (_ctx.warning)
              ? (_openBlock(), _createBlock(_component_BalAlert, {
                  key: 1,
                  class: "p-3 mb-4",
                  type: "warning",
                  size: "sm",
                  title: _ctx.warning.header,
                  description: _ctx.warning.body,
                  block: ""
                }, null, 8, ["title", "description"]))
              : _createCommentVNode("", true),
          (_ctx.trading.isLoading.value)
            ? (_openBlock(), _createBlock(_component_BalBtn, {
                key: 2,
                loading: true,
                "loading-label": 
          _ctx.trading.isGnosisTrade.value ? _ctx.$t('loadingBestPrice') : _ctx.$t('loading')
        ,
                block: ""
              }, null, 8, ["loading-label"]))
            : (_openBlock(), _createBlock(_component_BalBtn, {
                key: 3,
                label: _ctx.$t('preview'),
                disabled: _ctx.tradeDisabled,
                "loading-label": _ctx.$t('confirming'),
                color: "gradient",
                block: "",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.modalTradePreviewIsOpen = true), ["prevent"]))
              }, null, 8, ["label", "disabled", "loading-label"])),
          (_ctx.trading.isBalancerTrade.value)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_LightBulbIcon),
                _createVNode("span", null, [
                  _hoisted_4,
                  _createVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.switchToWETH())),
                    class: "text-green-500"
                  }, " Trade from WETH "),
                  _hoisted_5
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["shadow"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.modalTradePreviewIsOpen)
        ? (_openBlock(), _createBlock(_component_TradePreviewModalGP, {
            key: 0,
            trading: _ctx.trading,
            onTrade: _ctx.trade,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modalTradePreviewIsOpen = false))
          }, null, 8, ["trading", "onTrade"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}